import type { PartyListQuery, PartyType } from "@/types/parties";

// Query-key factory for the Borrower/Seller party surfaces (stale-after-save
// convention: every read registers here; every party mutation invalidates
// `partiesKeys.all`). Create also invalidates the portal-absorption prefix so
// the PortalAccountCard picks up the freshly minted standing account.

export const partiesKeys = {
  all: ["parties"] as const,
  list: (type: PartyType, query: PartyListQuery) =>
    ["parties", type, "list", query] as const,
  detail: (type: PartyType, id: string | undefined) =>
    ["parties", type, "detail", id] as const,
  search: (type: PartyType, term: string) =>
    ["parties", type, "search", term] as const,
};
